import React, { useCallback, useMemo, useRef, useState } from "react";
import { BackButton, Input, InputWithLabel } from "../../../components/micro";
import { headChat } from "../../../assets/image";
import { useEffect } from "react";
import { Trash } from "../../../assets/svg/AllSvg";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createServicesRequest } from "../../../redux/serviceRequest/slice";
import { Formik, Form } from "formik";
import * as Yup from "yup";

// validation on form
const validationSchema = Yup.object().shape({
  directorInformation: Yup.array()
    .of(
      Yup.object().shape({
        full_name: Yup.string().trim().required("Full Name is required"),
        email: Yup.string()
          .email("Invalid email")
          .required("Email is required"),
      })
    )
    .min(1, "At least one director information is required"),
});

const ForeignDirector = () => {
  const [noOfDirector, setNoOfDirector] = useState(0);
  const [directorInformation, setDirectorInformation] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const user_id = location?.state?.user_id;
  const company_id = location?.state?.company_id;
  const service = location?.state?.service;
  const buttonRef = useRef(null);

  const createServicesRequestData = useSelector(
    (store) => store?.serviceRequestData?.createServicesRequestStatus?.data
  );
  const createServicesRequestLoading = useSelector(
    (store) => store?.serviceRequestData?.loading
  );

  useEffect(() => {
    if (noOfDirector) {
      const newDirectors = Array.from({ length: noOfDirector }, () => ({
        full_name: "",
        email: "",
      }));
      setDirectorInformation(newDirectors);
    }
  }, [noOfDirector]);

  // Remove Director Information
  const removeDirectorInformation = useCallback(
    (index) => {
      setDirectorInformation((prev) => [
        ...prev.slice(0, index),
        ...prev.slice(index + 1),
      ]);
      setNoOfDirector((prevCount) => Math.max(0, prevCount - 1));
    },
    [setDirectorInformation]
  );

  // Update director
  const updateDirectorInformation = useCallback(
    (index, field, value) => {
      setDirectorInformation((prev) =>
        prev.map((item, i) =>
          i === index ? { ...item, [field]: value } : item
        )
      );
    },
    [setDirectorInformation]
  );

  const isValid = useMemo(() => {
    return directorInformation.every(
      (director) => director.full_name.trim() && director.email.trim()
    );
  }, [directorInformation]);

  // Proceed with request
  const handleProceed = () => {
    if (isValid) {
      const payload = {
        details: directorInformation,
        amount:
          service?.service_requests_count < service?.detail?.no_of_free_request
            ? 0
            : service?.detail?.price,
        user_id: user_id,
        company_id: company_id,
        service_id: service?.id,
      };
      dispatch(createServicesRequest(payload)).then((res) => {
        if (res.type !== "createServicesRequest/fulfilled") return;
        const { service_requests_count, detail } = service || {};
        const price = detail?.price || 0;
        if (
          service_requests_count < service?.detail?.no_of_free_request ||
          price <= 0
        ) {
          navigate("/approver");
        } else if (buttonRef.current) {
          buttonRef.current.click();
        } else {
          navigate("/approver");
        }
      });
    }
  };

  return (
    <div className="space-y-5">
      <BackButton
        onClick={() => {
          navigate("/service");
        }}
      />
      {/* Page Header */}
      <div className="sm:flex items-center sm:space-x-5 border-b-2 border-secondary_grey sm:pb-7 pb-2">
        <img src={headChat} alt="img" />
        <div className="sm:space-y-2 font-ebGaramond">
          <p className="sm:text-xl text-base">
            We see that you will need a request on:
          </p>
          <p className="sm:text-3xl text-xl">
            Appointment of New Foreign Director
          </p>
        </div>
      </div>
      {/* Payment Button */}
      <a
        className="hidden"
        ref={buttonRef}
        href={createServicesRequestData?.data?.url}
      >
        Pay Now
      </a>
      <Formik
        enableReinitialize={true}
        initialValues={{ directorInformation }}
        validationSchema={validationSchema}
        onSubmit={handleProceed}
      >
        {({ errors, handleBlur, handleChange }) => (
          <Form className="space-y-5">
            {/* Page Content */}
            <div className="space-y-3 border-b-2 border-secondary_grey pb-3">
              <p className="sm:text-2xl text-xl font-ebGaramond">
                Let us guide u though the process:
              </p>

              {/* 1 */}
              <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3 sm:text-base text-sm">
                <span>1.</span>
                <p>How many new local director are you appointing?</p>
              </div>
              <p className="sm:text-sm text-xs">
                Let us know how many new local director you are looking to
                appoint:
              </p>
              <div>
                <p className="text-xs mb-2">No. of new local director</p>
                <Input
                  type={"number"}
                  id={"number_of_new_local_director"}
                  name={"number_of_new_local_director"}
                  value={noOfDirector}
                  className={`p-2.5 w-full text-sm error-forms bg-transparent rounded border border-secondary_grey appearance-none focus:outline-none`}
                  min={0}
                  placeholder={"No. of new local director"}
                  onChange={(e) => {
                    setNoOfDirector(e.target.value);
                  }}
                />
              </div>
              {/* 2 */}
              <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg sm:text-base text-sm px-4 py-3">
                <span>2.</span>
                <p>Fill in the basic information of the new local director</p>
              </div>
              {directorInformation?.length ? (
                <div className="border-remove-bottom">
                  {directorInformation?.map((element, index) => (
                    <div
                      key={index}
                      className={`space-y-3 ${
                        !(directorInformation.length - 1 === index) &&
                        "pb-5 border-b-2 border-secondary_grey"
                      }`}
                    >
                      <div className="flex justify-between items-center">
                        <p className="text-sm">
                          Director {index + 1} Information:
                        </p>
                        {directorInformation.length > 1 && (
                          <button
                            className="p-4"
                            onClick={() => removeDirectorInformation(index)}
                          >
                            <Trash />
                          </button>
                        )}
                      </div>
                      <InputWithLabel
                        className={
                          errors.directorInformation?.[index]?.full_name
                            ? "input-error"
                            : "border"
                        }
                        idFromName={`directorInformation[${index}].full_name`}
                        type={"text"}
                        label={"Full Name"}
                        value={element.full_name}
                        onBlur={handleBlur}
                        onChange={(e) => {
                          updateDirectorInformation(
                            index,
                            "full_name",
                            e.target.value
                          );
                          handleChange(e);
                        }}
                        errors={errors.directorInformation?.[index]?.full_name}
                        errorsText={
                          errors.directorInformation?.[index]?.full_name
                        }
                      />
                      <InputWithLabel
                        className={
                          errors.directorInformation?.[index]?.email
                            ? "input-error"
                            : "border"
                        }
                        idFromName={`directorInformation[${index}].email`}
                        type={"email"}
                        label={"Email"}
                        value={element.email}
                        onBlur={handleBlur}
                        onChange={(e) => {
                          updateDirectorInformation(
                            index,
                            "email",
                            e.target.value
                          );
                          handleChange(e);
                        }}
                        errors={errors.directorInformation?.[index]?.email}
                        errorsText={errors.directorInformation?.[index]?.email}
                      />
                    </div>
                  ))}
                </div>
              ) : null}

              {/* 3 */}
              <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 sm:text-base text-sm py-3">
                <span>3.</span>
                <p>
                  We will send a link to the email provide. We will need the
                  specific director to login and provide the relevant
                  information for our KYC check
                </p>
              </div>
              {/* 4 */}
              <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 sm:text-base text-sm py-3">
                <span>4.</span>
                <p>
                  We will do a KYC checked and prepare relevant documents for
                  signature
                </p>
              </div>
              {/* 5 */}
              <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg sm:text-base text-sm px-4 py-3">
                <span>5.</span>
                <p>
                  Get the relevant document signed and we will handle the rest
                </p>
              </div>

              <p className="text-sm">
                Once the request is opened. You can easily manage it over at
                “On-Going” service page.
              </p>
            </div>
            <div className="flex items-center justify-between space-x-1 bg-light_primary_shades rounded-lg px-4 py-3">
              <p className="font-semibold">Total Payable :</p>
              <div>
                <p className="text-xs">
                  {service?.service_requests_count}/
                  {service?.detail?.no_of_free_request ?? 0} used
                </p>
                {service?.service_requests_count >=
                service?.detail?.no_of_free_request
                  ? `$${service?.detail?.price}`
                  : "Free"}
              </div>
            </div>
            <div className="box !rounded-xl flex items-center justify-between">
              <button
                type="submit"
                className={`${
                  !isValid || noOfDirector === 0 || createServicesRequestLoading
                    ? "btn-outline-disabled"
                    : "btn-theme"
                } uppercase`}
                disabled={
                  !isValid || noOfDirector === 0 || createServicesRequestLoading
                }
              >
                {createServicesRequestLoading
                  ? "Loading..."
                  : "Proceed with request"}
              </button>
              <div>
                <p className="text-xs">Total:</p>
                <p>
                  {service?.service_requests_count >=
                  service?.detail?.no_of_free_request
                    ? `$${service?.detail?.price}`
                    : "Free"}
                </p>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ForeignDirector;
